import type { PayoutRequestErrors } from 'api';

type PayoutDetailSection = {
  [key: string]: {
    [key: string]: string[];
  };
};

const PAYOUT_DETAILS_ERROR_PER_SECTION: PayoutDetailSection = {
  missing_capability: {
    general: ['payout_request']
  },
  general_data: {
    account: ['payout_request'],
    unique_reference: ['payout_request'],
    end_to_end_id: ['payout_request'],
    requested_execution_date: ['payout_request'],
    amount: ['payout_request'],
    purpose_code: ['payout_request'],
    local_instrument: ['payout_request']
  },
  creditor_account: {
    country_code: ['payout_request', 'receiver_bank'],
    iban: ['receiver_bank'],
    account_number: ['receiver_bank'],
    bank_clearing_system_id: ['receiver_bank'],
    bank_clearing_system_code: ['receiver_bank'],
    bank_bic: ['receiver_bank'],
    bank_branch_id: ['receiver_bank'],
    bank_name: ['receiver_bank']
  },
  ultimate_debtor: {
    full_name: ['sender'],
    name: ['sender'],
    email: ['sender'],
    mobile_number: ['sender', ''],
    birthdate: ['sender'],
    address: ['sender'],
    address_lines: ['sender'],
    street_name: ['sender'],
    postcode: ['sender'],
    city: ['sender'],
    country_code: ['sender'],
    state: ['sender'],
    country_of_birth_code: ['sender'],
    country_of_residence_code: ['sender'],
    id_number: ['sender'],
    id_type: ['sender'],
    type: ['sender']
  },
  creditor: {
    full_name: ['receiver'],
    name: ['receiver'],
    email: ['receiver'],
    birthdate: ['receiver'],
    postcode: ['receiver'],
    city: ['receiver'],
    country_code: ['receiver'],
    state: ['receiver'],
    mobile_number: ['receiver']
  },
  intermediary_agent: {
    bank_bic: ['intermediary_agent'],
    bank_name: ['intermediary_agent']
  },
  intermediary_agent_account: {
    account_number: ['intermediary_agent_account'],
    iban: ['intermediary_agent_account']
  }
};

export const countErrors = (errors: PayoutRequestErrors) => {
  if (!errors || !Object.keys(errors).length) {
    return {} as Record<string, number>;
  }
  const countSectionErrors = Object.entries(errors).reduce(
    (sectionErrors, [attribute, payoutErrors]) => {
      payoutErrors.forEach((payoutError) => {
        const sections =
          PAYOUT_DETAILS_ERROR_PER_SECTION[attribute]?.[payoutError.pointer];
        if (sections) {
          sections.forEach((section) => {
            sectionErrors[section] = (sectionErrors[section] || 0) + 1;
          });
        }
      });
      return sectionErrors;
    },
    {} as Record<string, number>
  );

  return countSectionErrors;
};
